import { signalStore, withState, withMethods, patchState, withComputed, withProps } from '@ngrx/signals';
import { computed, inject, resource } from '@angular/core';
import { WholesalerSettingsService } from './wholesaler-settings.service';

export const WholesalerSettingsStore = signalStore(
  { providedIn: 'root' },
  withState<{ filterValues: object }>({
    filterValues: <object>{},
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      filterValues: state?.filterValues?.(),
    })),
  })),
  withMethods(store => ({
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    }
  })),
  withProps((store, wholesalerSettingsService = inject(WholesalerSettingsService)) => ({
    resource: resource({
      request: store.filterValues,
      loader: async (request) => {
        const filter = request.request;
        const wholesalers = await wholesalerSettingsService.getWholesalers(filter);
        return wholesalers;
      },
    }),
  }))
);  